import {
    StyleSheet
} from "react-native";
import type {
    PaginationEllipsisDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    controlHeights,
    size
}: PaginationEllipsisDynamicStyleType) => {
    return {
        container: {
            height: controlHeights[size],
            width: controlHeights[size]
        }
    };
};
export default stylesheet;
